var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "mr10", attrs: { label: "评价状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择评价状态",
                            size: "small",
                            clearable: "",
                          },
                          on: { change: _vm.seachList },
                          model: {
                            value: _vm.tableFrom.isReply,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "isReply", $$v)
                            },
                            expression: "tableFrom.isReply",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已回复", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "未回复", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "mr10", attrs: { label: "商品搜索：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品名称",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.productSearch,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "productSearch", $$v)
                          },
                          expression: "tableFrom.productSearch",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入用户名称",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.nickname,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "nickname", $$v)
                          },
                          expression: "tableFrom.nickname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.seachList },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:product:reply:save"],
                      expression: "['admin:product:reply:save']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("添加虚拟评论")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.data },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品信息",
                  "min-width": "400",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.storeProduct
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "demo-image__preview acea-row row-middle",
                              },
                              [
                                _c("el-image", {
                                  staticClass: "mr10",
                                  staticStyle: {
                                    width: "30px",
                                    height: "30px",
                                  },
                                  attrs: {
                                    src: scope.row.storeProduct.image,
                                    "preview-src-list": [
                                      scope.row.storeProduct.image,
                                    ],
                                  },
                                }),
                                _c("div", { staticClass: "info line1" }, [
                                  _vm._v(
                                    _vm._s(scope.row.storeProduct.storeName)
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: "用户名称",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productScore",
                  label: "商品评分",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceScore",
                  label: "服务评分",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "评价内容", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "mb5 content_font" }, [
                          _vm._v(_vm._s(scope.row.comment || "-")),
                        ]),
                        scope.row.pics.length && scope.row.pics[0]
                          ? [
                              _c(
                                "div",
                                { staticClass: "demo-image__preview" },
                                _vm._l(scope.row.pics, function (item, index) {
                                  return _c("el-image", {
                                    key: index,
                                    staticClass: "mr5",
                                    attrs: {
                                      src: item,
                                      "preview-src-list": [item],
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantReplyContent",
                  label: "回复内容",
                  "min-width": "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(scope.row.merchantReplyContent || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "评价时间", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(" " + _vm._s(scope.row.createTime)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:product:reply:comment"],
                                expression: "['admin:product:reply:comment']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.reply(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("回复")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:product:reply:delete"],
                                expression: "['admin:product:reply:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(
                                  scope.row.id,
                                  scope.$index
                                )
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "添加评论",
                visible: _vm.dialogVisible,
                width: "700px",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("creat-comment", {
                key: _vm.timer,
                on: { getList: _vm.seachList },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }